module.exports = __webpack_public_path__ + "static/media/GalleryImage17.68618a95.jpg";